import { useEffect, useState } from "react";
import api from "@/lib/api";

function fmtDate(iso) { try { return new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }); } catch { return ""; } }

export default function Galeri() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/galeri").then((r) => setItems(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-2">Dokumentasi</div>
        <h1 className="font-heading font-bold text-3xl lg:text-5xl text-[#003A5C]">Galeri Kegiatan</h1>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {items.map((g) => (
          <div key={g.id} className="lift-card relative aspect-square rounded-2xl overflow-hidden bg-slate-200 group">
            <img src={g.image} alt={g.judul} className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#003A5C]/95 via-[#003A5C]/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex flex-col justify-end p-4">
              <div className="text-white text-sm font-semibold">{g.judul}</div>
              <div className="text-white/70 text-xs">{fmtDate(g.tanggal)}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
